import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { BrowserRouter as Router } from 'react-router-dom'

import App from './App.jsx'
import reportWebVitals from './reportWebVitals'
import ErrorBoundary from './components/ErrorBoundary'
import { sensors } from '@/util'

// polyfill
// import 'react-app-polyfill/ie11'
// import 'react-app-polyfill/stable'
import './bridge'

// 神策埋点传入登userid
sensors.getLoginSendUserId()
sensors.autoTrackAndInit()

// 兼容老版本登录，清除token
try {
  localStorage.removeItem('token')
} catch (error) {
  console.log(error)
}

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <ErrorBoundary>
    {/* <Router history={history}> */}
      <App />
    {/* </Router> */}
  </ErrorBoundary>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
